import { Component, OnInit, Injector, ChangeDetectionStrategy } from "@angular/core";
import { GenericBasicGUI } from "src/model/class/component classes/generic-basic-gui";

@Component({
    selector: "app-image",
    templateUrl: "./image.component.html",
    styleUrls: ["./image.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageComponent extends GenericBasicGUI implements OnInit {
  public idCustomInterfaceComponent: number = 0;

  public styles = {
    //todo
    //'background-image': '',
  };

  public stylesChild = {
    //'background-image': '',
  };

  /**
   * Giorgia -
   * @param injector The injector param is used by the parent classes to inject the services that they needed:
   * using this trick if the parent classes needed some specific service I don't need to inject them here
   * but I can do the injection in the specific class.
   */
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.idCustomInterfaceComponent = this.ComponentAPI.id;

    [this.styles, this.stylesChild] = super.HandleProperties(
      this.styles,
      this.stylesChild
    );

    if (!this.ShowingInDesktopVersion) {
      this.styles["width"] =
        Math.min(
          this.platform.width(),
          parseInt(this.styles["width"].replace("px", ""))
        ) + "px";
    }
  }

  ngOnDestroy() {
    this.onDestroyChildren();
  }
}
